import main from './eye2.svg';
import active from './eye-filled2.svg';
import disabled from './eye-gestalt2.svg';

export default { main, active, disabled };
